<script lang="ts">
	import { ETheme } from '$lib/dto/ETheme';
	import { appTheme, getAppThemeOrDefault, switchTheme } from '$lib/utils/themeUtils';
	import { onMount } from 'svelte';
	import { Icon } from 'svelte-icons-pack';
	import { FaMoon } from 'svelte-icons-pack/fa';
	import { FiSun } from 'svelte-icons-pack/fi';

	let spin = false;

	function triggerSpin(duration: number) {
		spin = true;
		setTimeout(() => (spin = false), duration);
	}

	onMount(() => {
		window
			.matchMedia('(prefers-color-scheme: dark)') //
			.addEventListener('change', (e) => {
				const useDarkMode = e.matches;
				if (
					($appTheme === ETheme.Dark && !useDarkMode) ||
					($appTheme === ETheme.Light && useDarkMode)
				) {
					switchTheme();
				}
			});
	});
</script>

<button
	title="Switch to {getAppThemeOrDefault() == 'light' ? 'dark' : 'light'} theme"
	class="button flex items-center py-1"
	type="button"
	data-testid="theme-switch-button"
	on:click={() => {
		triggerSpin(200);
		switchTheme();
	}}
>
	<span class:spin-right={spin} class="icon text-[13px]">
		<Icon className="hidden dark:block" src={FiSun} />
		<Icon className="dark:hidden" src={FaMoon} />
	</span></button
>

<style lang="less">
	.spin {
		animation: spin 575ms cubic-bezier(0.075, 0.82, 0.17, 1.135);
	}
	.spin-right {
		&:extend(.spin);

		@keyframes spin {
			0% {
				transform: scale(0) rotate(0deg);
			}
			100% {
				transform: scale(1) rotate(720deg);
			}
		}
	}
	.spin-left {
		&:extend(.spin);

		@keyframes spin {
			0% {
				transform: scale(0) rotate(0deg);
			}
			100% {
				transform: scale(1) rotate(-720deg);
			}
		}
	}
</style>
